import { render } from "./FormNumberField.vue?vue&type=template&id=00405f87&scoped=true"
import script from "./FormNumberField.vue?vue&type=script&lang=js"
export * from "./FormNumberField.vue?vue&type=script&lang=js"

import "./FormNumberField.vue?vue&type=style&index=0&id=00405f87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00405f87"]])

export default __exports__